<template>
  <div class="sign-in">
    <h1 class="mb-4">Bei SODA anmelden</h1>
    <v-form v-model="valid" ref="form">
      <v-text-field
        outlined
        v-model="username"
        v-if="!show_user_not_found_message"
        :rules="emailRules"
        label="Email Adresse"
        placeholder="mustermann@unternehmen.de"
        required
        v-on:input="prop_email()"
      />
      <v-alert outlined dismissible v-model="show_user_not_found_message" type="error">
        Nutzer mit dieser Email nicht gefunden.
      </v-alert>
      <v-text-field
        outlined
        v-model="password"
        v-if="!show_invalid_password_message"
        :append-icon="passwordVisible ? 'visibility' : 'visibility_off'"
        :rules="[
          passwordRules.required,
          passwordRules.mincnt,
          passwordRules.mincap,
          passwordRules.minnum,
          passwordRules.minspc,
        ]"
        :type="passwordVisible ? 'text' : 'password'"
        name="password"
        label="Passwort"
        @click:append="passwordVisible = !passwordVisible"
        required
      />
      <v-alert outlined dismissible v-model="show_invalid_password_message" type="error">
        Passwort falsch.
      </v-alert>
      <p class="caption" align="right">
        <a href="" v-bind:class="onForgotPassword" @click="onForgotPassword">Passwort vergessen?</a>
      </p>
      <v-btn outlined block color="primary" :disabled="!valid" @click="submit">
        Anmelden
      </v-btn>
    </v-form>
  </div>
</template>

<script>
import { signIn } from "./auth.js";
import { AmplifyEventBus } from "aws-amplify-vue";

export default {
  name: "SignInView",
  props: {
    email: String,
  },
  mounted() {
    if (this.email) {
      this.username = this.email;
    }
  },
  data() {
    return {
      valid: false,
      username: "",
      password: "",
      passwordVisible: false,
      show_user_not_found_message: false,
      show_invalid_password_message: false,
    };
  },
  computed: {
    emailRules() {
      return [
        (v) => !!v || "Email ist ein Pflichtfeld",
        (v) => /.+@.+\..+/.test(v) || "Feld muss eine Gültige Email enthalten",
      ];
    },
    passwordRules() {
      return {
        required: (value) => !!value || "Passwort ist ein Pflichtfeld",
        mincnt: (v) => v.length >= 8 || "Mindestens 8 Zeichen",
        mincap: (v) => /[A-Z]/.test(v) || "Mindestens 1 Großbuchstabe",
        minnum: (v) => /[0-9]/.test(v) || "Mindestens 1 Ziffer",
        minspc: (v) =>
          /[\^$*.\[\]{}()?"!@#%&/\\,><':;|_~`]/.test(v) ||
          "Mindestens 1 Sonderzeichen (^ $ * . [ ] { } ( ) ? \" ! @ # % & / \ , > < ' : ; | _ ~ `)",
      };
    },
  },
  methods: {
    prop_email() {
      this.$root.$emit("email", this.username);
    },
    async submit(ev) {
      ev.preventDefault();
      if (this.$refs.form.validate()) {
        //console.log(`SIGN IN username: ${this.username}, password: ${this.password}`);
        var res = await signIn(this.username, this.password);
        if (res) {
          if (res.code === "NotAuthorizedException") {
            this.show_invalid_password_message = true;
          } else if (res.code === "UserNotFoundException") {
            this.show_user_not_found_message = true;
          }
        }
      }
    },
    onForgotPassword(e) {
      e.preventDefault();
      AmplifyEventBus.$emit("authState", "passwordReset");
    },
  },
};
</script>
